import { render, staticRenderFns } from "./UpdateTestCentreDelegate.vue?vue&type=template&id=6335529b"
import script from "./UpdateTestCentreDelegate.vue?vue&type=script&lang=js"
export * from "./UpdateTestCentreDelegate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports